import { useState } from 'react';

import { Field, FieldLabel } from '@/components/ui/field';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  HWCG_CONTACT_LIST_IDS,
  HWCG_GROUP_LABELS,
  type HwcgContactListId,
} from 'components/IncidentConfig/CreateIncident/hwcgGroupActions';

import {
  HwcgDirectoryImportDialog,
  type DirectoryImportField,
} from './HwcgDirectoryImportDialog';

const CONTACT_FIELDS: DirectoryImportField[] = [
  { field: 'fullName', label: 'Full name' },
  { field: 'firstName', label: 'First name' },
  { field: 'lastName', label: 'Last name' },
  { field: 'email', label: 'Email' },
  { field: 'phone', label: 'Phone' },
  { field: 'memberCompany', label: 'Member company' },
  { field: 'serviceProvider', label: 'Service provider' },
  { field: 'primaryCategory', label: 'Primary category' },
  { field: 'secondaryCategory', label: 'Secondary category' },
  { field: 'pocContact', label: 'POC contact' },
  { field: 'authorizedIndividual', label: 'Authorized individual' },
  { field: 'memberCompanyExclusive', label: 'Member Company Exclusive' },
];

const REACHABLE_FIELDS = [
  'fullName',
  'firstName',
  'lastName',
  'email',
  'phone',
  'serviceProvider',
];

function contactLabel(fields: Record<string, string | boolean | null>) {
  const name = [fields.firstName, fields.lastName]
    .filter((part) => typeof part === 'string' && part)
    .join(' ');
  return (
    name ||
    (typeof fields.email === 'string' && fields.email) ||
    (typeof fields.phone === 'string' && fields.phone) ||
    (typeof fields.serviceProvider === 'string' && fields.serviceProvider) ||
    '—'
  );
}

export function HwcgContactImportDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const [constituency, setConstituency] = useState<HwcgContactListId>('eoc');
  return (
    <HwcgDirectoryImportDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) setConstituency('eoc');
        onOpenChange(next);
      }}
      kind="contacts"
      title="Import contacts"
      noun="contact"
      nounPlural="contacts"
      fields={CONTACT_FIELDS}
      requiredAnyOf={REACHABLE_FIELDS}
      constituency={constituency}
      rowLabel={contactLabel}
      uploadExtra={
        <Field>
          <FieldLabel htmlFor="hwcg-contact-import-list">
            Import into
          </FieldLabel>
          <Select
            value={constituency}
            onValueChange={(next) =>
              setConstituency(String(next) as HwcgContactListId)
            }
          >
            <SelectTrigger
              id="hwcg-contact-import-list"
              size="sm"
              className="tw:w-full"
            >
              <SelectValue>{HWCG_GROUP_LABELS[constituency]}</SelectValue>
            </SelectTrigger>
            <SelectContent className="dark">
              {HWCG_CONTACT_LIST_IDS.map((id) => (
                <SelectItem key={id} value={id}>
                  {HWCG_GROUP_LABELS[id]}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Field>
      }
    />
  );
}
